import { render, staticRenderFns } from "./TheModalTitulo.vue?vue&type=template&id=cce94374&"
import script from "./TheModalTitulo.vue?vue&type=script&lang=js&"
export * from "./TheModalTitulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports